<template>
  <div class="container">
    <img class="booth-title" :src="$getImgUrl(`/site-images/activity/ams2021/booth-title.png`)">
    <img class="scan-btn" src="../../../assets/images/2021/booth-scan-btn.png" @click="scanCode()">
    <img class="booth-info" :src="$getImgUrl(`/site-images/activity/ams2021/booth-info.png`)">

    <van-overlay class="hasPrize-box" :show="showProduct" :lock-scroll="false">
      <div class="product">
        <img class="close" @click="showProduct=false" src="../../../assets/images/new-year/close.png">
        <div class="scan-result">
          {{scanResult}}
        </div>
        <img v-if="this.productInfo.imageName" class="product-bg" :src="$getImgUrl(`/site-images/activity/ams2021/${productInfo.imageName}.png`)">
      </div>
      <div class="btn">
         <img  @click="goToWeb()"  src="../../../assets/images/2021/exchange-btn.png">
      </div>
    </van-overlay>

  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import { sessionStorageUtils } from '@/utils/sessionstorage'
import activityApi from '@/api/activity'
export default {
  created () {
    this.clientInfo = userUtils.getClientInfo()
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
  },
  mounted () {
    console.log(1)
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
      sessionStorage.setItem('flag', '0')
    }

    this.wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
    if (this.$route.query.productCode) {
      let flag = sessionStorage.getItem('flag') || ''
      if (flag !== '1') {
        this.boothScan(this.$route.query.productCode)
        sessionStorage.setItem('flag', '1')
      }
    }
  },
  beforeDestroy () {
    sessionStorage.setItem('flag', '0')
  },
  data () {
    return {
      clientInfo: {},
      showProduct: false,
      productInfo: {},
      scanResult: '',
      imageName: '',
      wxUserInfo: {}
    }
  },
  computed: {
    getProductImg () {
      if (this.productInfo.imageName) {
        return require(`../../../assets/images/2021/${this.productInfo.imageName}.png`)
      }
      return ''
    }
  },
  methods: {
    goToWeb () {
      sessionStorage.setItem('flag', '1')
      this.$router.push({ name: 'activity-2021-activity-booth-mall' })
    },
    // 扫码
    scanCode () {
      console.log('扫码')
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          console.log('扫码成功---')
          console.log(res)
          let resultList = res.resultStr.split('=')
          if (resultList[1]) {
            let resultCode = resultList[1].split('#')
            this.boothScan(resultCode[0])
          } else {
            this.boothScan(res)
          }
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },

    // 扫码结果
    boothScan (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      let data = {
        productCode: value,
        openId: this.wxUserInfo.openId
      }
      activityApi.boothScan(data).then(res => {
        this.$toast.clear()
        console.log(res)
        if (res.data.resultCode === '0') {
          if (res.data.resultData.productInfo && res.data.resultData.productInfo != null) {
            this.productInfo = res.data.resultData.productInfo
            this.scanResult = res.data.resultData.scanResult
            sessionStorage.setItem('flag', '0')
            this.showProduct = true
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100vw;
  background-image: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/site-images//activity/ams2021/booth-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
}
.bg{
    width: 100vw;
    display: block;
}
.booth-title{
  width: 80%;
  margin-left: 10%;
  margin-top:30px;
}
.booth-info{
  width: 90%;
  margin-left: 5%;
  margin-top: 40px;
}
.dialogContext {
    padding: 20px;
    text-align: center;
}

.scan-btn{
  margin-left: calc(50vw - 60px);
  //margin-left: 50vw ;
  margin-top: 30px;

  //margin-left: 50vw ;
  // position: absolute;
  // left: calc(50vw - 60px);
  // top: 240px;
  width: 120px;
  animation:mymove 4s infinite;
  animation-direction:alternate;          /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
}

@keyframes mymove {
    0%{
        transform: scale(1);  /*开始为原始大小*/
    }
    25%{
        transform: scale(1.2); /*放大1.1倍*/
    }
    50%{
        transform: scale(1);
    }
    75%{
        transform: scale(1.2);
    }
}

.hasPrize-box{
  width: 100%;
  .product{
    width: 100%;
    //height: 500px;
    //margin-left: 6%;
    margin-top: 2%;
    position: relative;
    .product-bg{
      width: 80%;
      margin-left: 10%;
      margin-top: 0px;
    }
    .scan-result{
      position:relative;
      top: 55px;
      text-align: center;
      font-size: 16px;
    }
    .product-item{
      width: 80%;
      position: absolute;
      top: 120px;
      left: 10%;
    }
  }
  .btn{
    width: 110px;
    position: relative;
    top: 10px;
    margin: 0 auto;
    img{
      width: 100%;
    }
  }
}
.close{
  position: relative;
  width: 30px;
  left: calc(100% - 50px);
  margin-bottom: 5px;
}
</style>
